<template>
  <v-col cols="12" class="pa-0">
    <v-sheet ref="scroll" :style="contentsHeight" class='overflow-y-auto scroll-target box'>
      <template v-for='(item, index) in messages'>
        <template v-if="(item.from != user.uid) && item.visible">
          <v-col cols="12" class="px-2 pt-1 pb-0" :key='item.key'>
            <v-row align="center" class="ma-0">
              <v-col cols="1" class="pa-0">
                <v-col class="pa-0" align="center">
                  <v-avatar size='34'>
                    <img v-if="getAvatar(item)" :src='getAvatar(item)'>
                    <v-avatar v-else size="32" color="primary"><span class="font-weight-bold white--text" style="font-size:23px; user-select: none;">{{ getNamePrefix(item) }}</span></v-avatar>
                  </v-avatar>
                </v-col>
                <v-col class="pa-0" justify="center">
                  <p class="name">{{ getFromUserName(item) }}</p>
                </v-col>
              </v-col>
              <v-col cols="11" class="pa-0">
                <v-col v-if="item.attention.length != 0" cols="12" class="py-1 px-0">
                  <template v-for="attn in item.attention">
                    <v-chip :key="attn" x-small outlined :color="attn == data.key ? 'error' : 'grey'" class="px-2 py-0 mr-1">{{ getUserName(attn) }}</v-chip>
                  </template>
                </v-col>
                <v-col cols="12" class="pa-0" justify="center">
                  <template v-if="item.type == 'text'">
                    <text-highlight v-if="mode == 'search'" :queries="search" class="py-1 px-2 text">{{ item.content }}</text-highlight>
                    <span v-else class='py-1 px-2 text'>{{ item.content }}</span>
                  </template>
                  <template v-else-if="item.type == 'photo'">
                    <v-row align="center" class="ma-0">
                      <v-card
                        v-if="item.note"
                        max-width="344"
                        outlined
                        class="l-color"
                        :ripple="false"
                        @click="onImageView(item)"
                      >
                        <v-list-item class="py-1 px-2">
                          <v-list-item-avatar
                            tile
                            size="48"
                            color="grey"
                            class="my-0 mx-0"
                          >
                            <v-img v-if="item.content && item.content.thumbnail" @click="onImageView(item)" style="float:right;" :src="item.content.thumbnail" max-width='80' height='80'/>
                            <v-icon v-else size="48">mdi-image</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content v-if="item.note" class="pa-0">
                            <text-highlight v-if="mode == 'search'" :queries="search" class="caption pl-4 pr-0" align="left">{{ item.note }}</text-highlight>
                            <div v-else class="caption pl-4 pr-0" align="left">{{ item.note }}</div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                      <v-sheet v-else height="80" color="transparent">
                        <v-img v-if="item.content && item.content.thumbnail" @click="onImageView(item)" :src="item.content.thumbnail" max-width='80' height='80' />
                        <v-icon v-else size="80">mdi-image</v-icon>
                      </v-sheet>
                    </v-row>
                  </template>
                  <template v-else-if="item.type == 'share'">
                    <template v-if="checkSharePrivileges(item)">
                      <v-row align="center" class="ma-0">
                        <v-card
                          max-width="344"
                          outlined
                          class="l-color"
                          :ripple="false"
                          @click.stop="onOpenItem(item)"
                        >
                          <v-list-item class="py-1 px-2">
                            <v-icon class="pr-1" size="38" color="success">{{ getShareIcon(item) }}</v-icon>
                            <v-list-item-content class="pa-0" style="display: block;">
                              <template v-if="item.note">
                                <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                                <div v-else class="caption" align="left">{{ item.note }}</div>
                                <v-list-item-title>
                                  <v-chip x-small color="success" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                                </v-list-item-title>
                              </template>
                              <template v-else>
                                <v-list-item-title>
                                  <v-chip small color="success" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                                </v-list-item-title>
                              </template>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-card
                        max-width="30"
                        outlined
                          >
                          <v-icon class="pr-1" size="28">mdi-cancel</v-icon>
                      </v-card>
                    </template>
                  </template>
                  <template v-else-if="item.type == 'drive'">
                    <v-row align="center" class="ma-0">
                      <v-card
                        max-width="344"
                        outlined
                        class="l-color"
                        :ripple="false"
                        @click.stop="onOpenItem(item)"
                      >
                        <v-list-item class="py-1 px-2">
                          <v-icon class="pr-1" size="38" color="deep-orange darken-4">{{ getShareIcon(item) }}</v-icon>
                          <v-list-item-content class="pa-0" style="display: block;">
                            <template v-if="item.note">
                              <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                              <div v-else class="caption" align="left">{{ item.note }}</div>
                              <v-list-item-title>
                                <v-chip x-small color="deep-orange darken-4" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                              </v-list-item-title>
                            </template>
                            <template v-else>
                              <v-list-item-title>
                                <v-chip small color="deep-orange darken-4" dark><span class="overflow-text-hidden">{{ getShareName(item)}}</span></v-chip>
                              </v-list-item-title>
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-row>
                  </template>
                  <template v-else-if="item.type == 'emoji'">
                    <v-row align="center" class="ma-0">
                      <v-card
                        v-if="item.note"
                        max-width="344"
                        outlined
                        class="l-color"
                      >
                        <v-list-item class="py-1 px-2">
                          <span color="primary" class="py-0 emoji">{{ item.content }}</span>
                          <v-list-item-content v-if="item.note" class="pa-0">
                            <text-highlight v-if="mode == 'search'" :queries="search" class="caption pl-4 pr-0" align="left">{{ item.note }}</text-highlight>
                            <div class="caption pl-4 pr-0" align="left">{{ item.note }}</div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                      <span v-else color="primary" class="py-0 emoji">{{ item.content }}</span>
                    </v-row>
                  </template>
                  <template v-else-if="item.type == 'task'">
                    <template v-if="checkPrivileges('plan')">
                      <v-row align="center" class="ma-0">
                        <v-card
                          max-width="344"
                          outlined
                          class="l-color"
                          :ripple="false"
                          @click.stop="onOpenItem(item)"
                        >
                          <v-list-item class="py-1 px-2">
                            <v-icon class="pr-1" size="38">{{ getTaskIcon(item) }}</v-icon>
                              <v-list-item-content class="pa-0" style="display: block;">
                                <template v-if="item.note">
                                  <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                                  <div v-else class="caption" align="left">{{ item.note }}</div>
                                  <v-list-item-title>
                                    <v-chip x-small :style="getTaskColor(item)"><span class="overflow-text-hidden">{{ getTaskName(item) }}</span></v-chip>
                                  </v-list-item-title>
                                </template>
                                <template v-else>
                                  <v-list-item-title>
                                    <v-chip small :style="getTaskColor(item)"><span class="overflow-text-hidden">{{ getTaskName(item) }}</span></v-chip>
                                  </v-list-item-title>
                                </template>
                              </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-card
                        max-width="30"
                        outlined
                          >
                          <v-icon class="pr-1" size="28">mdi-cancel</v-icon>
                      </v-card>
                    </template>
                  </template>
                  <template v-else-if="item.type == 'student'">
                    <template v-if="checkStudentPrivileges(item)">
                      <v-row align="center" class="ma-0">
                        <v-card
                          max-width="344"
                          outlined
                          class="l-color"
                          :ripple="false"
                          @click.stop="onOpenItem(item)"
                        >
                          <v-list-item class="py-1 px-2">
                            <v-icon class="pr-1" size="38" color="primary">mdi-school</v-icon>
                            <v-list-item-content class="pa-0" style="display: block;">
                              <template v-if="item.note">
                                <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                                <div v-else class="caption" align="left">{{ item.note }}</div>
                                <v-list-item-title>
                                  <v-chip x-small color="primary" dark><span class="overflow-text-hidden">{{ getStudentName(item) }}</span></v-chip>
                                </v-list-item-title>
                              </template>
                              <template v-else>
                                <v-list-item-title>
                                  <v-chip small color="primary" dark><span class="overflow-text-hidden">{{ getStudentName(item) }}</span></v-chip>
                                </v-list-item-title>
                              </template>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-card
                        max-width="30"
                        outlined
                          >
                          <v-icon class="pr-1" size="28">mdi-cancel</v-icon>
                      </v-card>
                    </template>
                  </template>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <template>
                    <span class="grey--text" style='font-size: 10px;'>{{ item.createdAt | moment }}</span>
                  </template>
                </v-col>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </v-col>
        </template>
        <template v-else-if="item.visible">
          <v-col cols="12" class="px-2 pt-1 pb-0" align="end" :key='item.key'>
            <v-row align="center">
              <v-col v-if="item.attention.length != 0" cols="12" class="py-1 pr-4" align="end">
                <template v-for="attn in item.attention">
                  <v-chip :key="attn" x-small outlined color="grey" dark class="px-2 py-0 mr-1">{{ getUserName(attn) }}</v-chip>
                </template>
              </v-col>
              <v-col cols="12" class="py-0" align="end">
                <v-row align="center" justify="end" class="pr-5">
                <span class="read" :style="item.read ? 'background-color: #1976D2;' : 'background-color: #FFC107;'">{{ getCounter(item) }}</span>
                <template v-if="item.type == 'text'">
                  <text-highlight v-if="mode == 'search'" :queries="search" class="py-1 px-2 text-r">{{ item.content }}</text-highlight>
                  <span v-else class='py-1 px-2 text-r'>{{ item.content }}</span>
                </template>
                <template v-else-if="item.type == 'photo'">
                  <v-card
                    v-if="item.note"
                    max-width="344"
                    outlined
                    class="r-color"
                    :ripple="false"
                  >
                    <v-list-item class="py-1 px-2">
                      <v-list-item-avatar
                        tile
                        size="48"
                        color="grey"
                        class="my-0 mx-0"
                      >
                        <v-img v-if="item.content && item.content.thumbnail" @click="onImageView(item)" style="float:right;" :src="item.content.thumbnail" max-width='80' height='80'/>
                        <v-icon v-else size="48">mdi-image</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content v-if="item.note" class="pa-0">
                        <text-highlight v-if="mode == 'search'" :queries="search" class="caption pl-4 pr-0" align="left">{{ item.note }}</text-highlight>
                        <div v-else class="caption pl-4 pr-0" align="left">{{ item.note }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                  <v-sheet v-else height="80" color="transparent">
                    <v-img v-if="item.content && item.content.thumbnail" @click="onImageView(item)" style="float:right;" :src="item.content.thumbnail" max-width='80' height='80'/>
                    <v-icon v-else size="80">mdi-image</v-icon>
                  </v-sheet>
                </template>
                <template v-else-if="item.type == 'share'">
                  <template v-if="checkSharePrivileges(item)">
                    <v-card
                      max-width="344"
                      outlined
                      class="r-color"
                      :ripple="false"
                      @click.stop="onOpenItem(item)"
                    >
                      <v-list-item class="py-1 px-2">
                        <v-icon class="pr-1" size="38" color="success">{{ getShareIcon(item) }}</v-icon>
                        <v-list-item-content class="pa-0" style="display: block;">
                          <template v-if="item.note">
                            <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                            <div v-else class="caption" align="left">{{ item.note }}</div>
                            <v-list-item-title>
                              <v-chip x-small color="success" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                            </v-list-item-title>
                          </template>
                          <template v-else>
                            <v-list-item-title>
                              <v-chip small color="success" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                            </v-list-item-title>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </template>
                  <template v-else>
                    <v-card
                      max-width="30"
                      outlined
                        >
                        <v-icon class="pr-1" size="28">mdi-cancel</v-icon>
                    </v-card>
                  </template>
                </template>
                <template v-else-if="item.type == 'drive'">
                  <v-card
                    max-width="344"
                    outlined
                    class="r-color"
                    :ripple="false"
                    @click.stop="onOpenItem(item)"
                  >
                    <v-list-item class="py-1 px-2">
                      <v-icon class="pr-1" size="38" color="deep-orange darken-4">{{ getShareIcon(item) }}</v-icon>
                      <v-list-item-content class="pa-0" style="display: block;">
                        <template v-if="item.note">
                          <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                          <div v-else class="caption" align="left">{{ item.note }}</div>
                          <v-list-item-title>
                            <v-chip x-small color="deep-orange darken-4" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                          </v-list-item-title>
                        </template>
                        <template v-else>
                          <v-list-item-title>
                            <v-chip small color="deep-orange darken-4" dark><span class="overflow-text-hidden">{{ getShareName(item) }}</span></v-chip>
                          </v-list-item-title>
                        </template>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </template>
                <template v-else-if="item.type == 'emoji'">
                  <v-card
                    v-if="item.note"
                    max-width="344"
                    outlined
                    class="r-color"
                  >
                    <v-list-item class="py-1 px-2">
                      <span color="primary" class="emoji">{{ item.content }}</span>
                      <v-list-item-content v-if="item.note" class="pa-0">
                        <text-highlight v-if="mode == 'search'" :queries="search" class="caption pl-4 pr-0" align="left">{{ item.note }}</text-highlight>
                        <div v-else class="caption pl-4 pr-0" align="left">{{ item.note }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                  <span v-else color="primary" class="py-0 emoji">{{ item.content }}</span>
                </template>
                <template v-else-if="item.type == 'task'">
                  <v-card
                    max-width="344"
                    outlined
                    class="r-color"
                    :ripple="false"
                    @click.stop="onOpenItem(item)"
                  >
                    <v-list-item class="py-1 px-2">
                      <v-icon class="pr-1" size="38">{{ getTaskIcon(item) }}</v-icon>
                      <v-list-item-content class="pa-0" style="display: block;">
                        <template v-if="item.note">
                          <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                          <div v-else class="caption" align="left">{{ item.note }}</div>
                          <v-list-item-title>
                            <v-chip x-small :style="getTaskColor(item)" dark><span class="overflow-text-hidden">{{ getTaskName(item) }}</span></v-chip>
                          </v-list-item-title>
                        </template>
                        <template v-else>
                          <v-list-item-title>
                            <v-chip small :style="getTaskColor(item)" dark><span class="overflow-text-hidden">{{ getTaskName(item) }}</span></v-chip>
                          </v-list-item-title>
                        </template>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </template>
                <template v-else-if="item.type == 'student'">
                  <template v-if="checkStudentPrivileges(item)">
                    <v-card
                      max-width="344"
                      outlined
                      class="r-color"
                      :ripple="false"
                      @click.stop="onOpenItem(item)"
                    >
                      <v-list-item class="py-1 px-2">
                        <v-icon class="pr-1" size="38" color="primary">mdi-school</v-icon>
                        <v-list-item-content class="pa-0" style="display: block;">
                          <template v-if="item.note">
                            <text-highlight v-if="mode == 'search'" :queries="search" class="caption" align="left">{{ item.note }}</text-highlight>
                            <div v-else class="caption" align="left">{{ item.note }}</div>
                            <v-list-item-title>
                              <v-chip x-small color="primary" dark><span class="overflow-text-hidden">{{ getStudentName(item) }}</span></v-chip>
                            </v-list-item-title>
                          </template>
                          <template v-else>
                            <v-list-item-title>
                              <v-chip small color="primary" dark><span class="overflow-text-hidden">{{ getStudentName(item) }}</span></v-chip>
                            </v-list-item-title>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </template>
                  <template v-else>
                    <v-card
                      max-width="30"
                      outlined
                        >
                        <v-icon class="pr-1" size="28">mdi-cancel</v-icon>
                    </v-card>
                  </template>
                </template>
                </v-row>
              </v-col>
              <v-col cols="12" class="py-0" align="end">
                <v-row align="center" justify="end" class="pr-2">
                  <v-col cols="auto" class="py-0 pr-0">
                    <span class='grey--text' style='font-size: 10px; padding-top: 2px; padding-bottom: 0px;'>{{ item.createdAt | moment }}</span>
                  </v-col>
                  <v-col cols="auto" class="pl-3 pa-0">
                    <p v-if="mode != 'search' && checkStudentPrivileges(item)" class="edit" @click.stop="onEditItem(item)">編集</p>
                  </v-col>
                  <v-col cols="auto" class="py-0">
                    <p v-if="mode != 'search'" class="delete" @click.stop="onRemoveItem(item)">削除</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-row v-if="mode == 'search'" :key="index + ' divier'"></v-row>
        </template>
      </template>
    </v-sheet>
  </v-col>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import moment from 'moment'
import TextHighlight from 'vue-text-highlight'
Vue.component('text-highlight', TextHighlight)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      shares: 'shares/shares',
      publicUsers: 'publicUsers/users',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      scheduleTasks: 'scheduleTasks/events',
      templateTasks: 'templateTasks/templates',
      students: 'students/students'
    })
  },
  data () {
    return {
    }
  },
  props: [ 'mode', 'item', 'contentsHeight', 'messages', 'search' ],
  watch: {
    messages () {
      this.checkRead()
      this.onGoto()
    },
    $route (to, from) {
      if (to.path === '/chat') {
        this.onGoto()
      }
    }
  },
  created () {
  },
  mounted () {
    this.checkRead()
    this.onGoto()
  },
  methods: {
    getUserName (item) {
      var index = null
      index = this.users.findIndex(u => u.key === item)
      if (index !== -1) {
        return this.users[index].name
      }
      index = this.publicUsers.findIndex(u => u.key === item)
      if (index !== -1) {
        return this.publicUsers[index].name
      }
      return ''
    },
    getCounter (item) {
      if (!item.read) {
        return '未読'
      }
      if (item.chatType === 'user' || !item.whoRead) {
        return '既読'
      }
      return '既読 ' + String(item.whoRead.length)
    },
    checkSharePrivileges (item) {
      if (this.data && this.data.role === 'teacher') {
        var index = this.shares.findIndex(share => share.key === item.content)
        if (index !== -1) {
          return this.shares[index].scope !== 'restrict'
        } else {
          return false
        }
      }
      return true
    },
    checkStudentPrivileges (item) {
      if (this.checkPrivileges('edit')) {
        return true
      }
      if (item.type !== 'student') {
        return true
      }
      var status = false
      var index = this.students.findIndex(s => s.key === item.content)
      if (index !== -1) {
        if (this.students[index].enable) {
          status = this.students[index].status === 6
        }
      }
      return status
    },
    checkRead () {
      if (this.mode === 'search') {
        return
      }
      var ba = false
      var dbRef = null
      const db = firebase.firestore()
      var batch = db.batch()
      this.messages.forEach(message => {
        if (message.from !== this.user.uid && message.visible) {
          if (message.read) {
            if (message.whoRead && !message.whoRead[this.user.uid]) {
              dbRef = db.collection('chats').doc(message.parentKey).collection('data').doc(message.key)
              batch.update(dbRef, { whoRead: firebase.firestore.FieldValue.arrayUnion(this.user.uid) })
              ba = true
            }
          } else {
            dbRef = db.collection('chats').doc(message.parentKey).collection('data').doc(message.key)
            var payload = {
              read: true,
              updatedAt: parseInt(new Date().getTime())
            }
            batch.update(dbRef, payload)
            var dbRef2 = db.collection('chats').doc(message.parentKey).collection('data').doc(message.key)
            batch.update(dbRef2, { whoRead: firebase.firestore.FieldValue.arrayUnion(this.user.uid) })
            ba = true
          }
        }
      })
      if (ba) {
        batch.commit().then(function () {})
      }
    },
    getAvatar (item) {
      var index = -1
      var url = null
      index = this.users.findIndex(user => user.key === item.from)
      if (index !== -1) {
        if (this.users[index].avatar) {
          url = this.users[index].avatar.thumbnail
        }
      }
      index = this.publicUsers.findIndex(user => user.key === item.from)
      if (index !== -1) {
        if (this.publicUsers[index].avatar) {
          url = this.publicUsers[index].avatar.thumbnail
        }
      }
      return url
    },
    getFromUserName (item) {
      var index = -1
      var name = '？'
      index = this.users.findIndex(user => user.key === item.from)
      if (index !== -1) {
        name = this.users[index].name
      }
      index = this.publicUsers.findIndex(user => user.key === item.from)
      if (index !== -1) {
        name = this.publicUsers[index].name
      }
      return name
    },
    getNamePrefix (item) {
      var index = -1
      var name = '？'
      index = this.users.findIndex(user => user.key === item.from)
      if (index !== -1) {
        name = this.users[index].name.slice(0, 1)
      }
      index = this.publicUsers.findIndex(user => user.key === item.from)
      if (index !== -1) {
        name = this.publicUsers[index].name.slice(0, 1)
      }
      return name
    },
    onGoto () {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.scroll-target')
        if (container) {
          const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
          pause(10).then(() => {
            container.scrollTop = container.scrollHeight + 1000
          })
        }
      })
    },
    onImageView (item) {
      this.$emit('openImage', { item })
    },
    getShareIcon (item) {
      if (item.type === 'share') {
        const index = this.shares.findIndex(share => share.key === item.content)
        if (index === -1) {
          return 'mdi-image-broken-variant'
        }
        if (typeof this.$MIMEICON[this.shares[index].contents.mimeType] !== 'undefined') {
          return this.$MIMEICON[this.shares[index].contents.mimeType]
        } else {
          return 'mdi-folder'
        }
      } else if (item.type === 'drive') {
        if (typeof this.$MIMEICON[item.content.mimeType] !== 'undefined') {
          return this.$MIMEICON[item.content.mimeType]
        } else {
          return 'mdi-file-document-box-outline'
        }
      }
    },
    onOpenItem (item) {
      this.$emit('open', { item })
    },
    onEditItem (item) {
      this.$emit('edit', { item })
    },
    onRemoveItem (item) {
      this.$emit('remove', { item })
    },
    getShareName (item) {
      if (item.type === 'share') {
        const index = this.shares.findIndex(share => share.key === item.content)
        if (index === -1) {
          return 'Not found'
        }
        return this.shares[index].name
      } else {
        if (typeof item.content.name !== 'undefined') {
          return item.content.name
        }
        return ''
      }
    },
    getTaskIcon (item) {
      var icon = 'mdi-calendar-check'
      if (item.content.type === 'event') {
        icon = 'mdi-calendar-star'
      }
      return icon
    },
    getTaskName (item) {
      var name = 'N/A'
      var index = -1
      if (item.content.type === 'event') {
        index = this.scheduleEvents.findIndex(event => event.key === item.content.key)
        if (index !== -1) {
          var template = this.scheduleEvents[index].template
          var date = this.scheduleEvents[index].startDate
          index = this.templateEvents.findIndex(event => event.key === template)
          if (index !== -1) {
            name = this.templateEvents[index].title + '（' + date + '）'
          }
        }
      } else {
        index = this.scheduleTasks.findIndex(event => event.key === item.content.key)
        if (index !== -1) {
          template = this.scheduleTasks[index].template
          date = this.scheduleTasks[index].startDate
          index = this.templateTasks.findIndex(event => event.key === template)
          if (index !== -1) {
            name = this.templateTasks[index].title + '（' + date + '）'
          }
        }
      }
      return name
    },
    getTaskColor (item) {
      var index = -1
      if (item.content.type === 'event') {
        index = this.scheduleEvents.findIndex(event => event.key === item.content.key)
        if (index !== -1) {
          var template = this.scheduleEvents[index].template
          index = this.templateEvents.findIndex(event => event.key === template)
          if (index !== -1) {
            return 'background-color: ' + this.getDescriptionColor(this.templateEvents[index], this.$COLOR_DEFAULT) + '; color: white;'
          }
        }
      } else {
        index = this.scheduleTasks.findIndex(event => event.key === item.content.key)
        if (index !== -1) {
          template = this.scheduleTasks[index].template
          index = this.templateTasks.findIndex(event => event.key === template)
          if (index !== -1) {
            var task = this.templateTasks[index]
            const bg = 'background-color: ' + this.getDescriptionColor(task, this.$COLOR_LIGHT) + '; '
            const border = 'border: 1px solid ' + this.getDescriptionColor(task, this.$COLOR_DEFAULT) + '; '
            const font = 'color: ' + this.getDescriptionColor(task, this.$COLOR_DARK) + '; '
            return bg + border + font
          }
        }
      }
      return 'background-color: #9E9E9E;'
    },
    getStudentName (item) {
      var name = '（削除済）'
      var index = this.students.findIndex(s => s.key === item.content)
      if (index !== -1) {
        if (this.students[index].enable) {
          name = this.students[index].name
          if (name === '' || name === null) {
            name = this.students[index].seiY + ' ' + this.students[index].meiY
          }
          name += '（' + this.getGradeName(this.getGrade(this.students[index])) + '）'
        }
      }
      return name
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MM月DD日 HH時mm分')
    }
  }
}
</script>

<style scoped>
.v-image {
  cursor: pointer;
}
img {
  object-fit: cover !important;
}

p.delete {
  border-radius: 8px;
  border-width: 1px;
  border: 1px solid;
  text-align:center;
  margin: 2px;
  color: red;
  background-color: white;
  font-size: 10px;
  line-height: 14px;
  width: 40px;
  height: 14px;
  cursor: pointer;
}

p.edit {
  border-radius: 8px;
  border-width: 1px;
  border: 1px solid;
  text-align:center;
  margin: 2px;
  color: #388E3C;
  background-color: white;
  font-size: 10px;
  line-height: 14px;
  width: 40px;
  height: 14px;
  cursor: pointer;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

span.read {
  border-radius: 8px;
  padding: 0px;
  margin-right: 2px;
  font-size: 9px;
  line-height: 12px;
  width: 40px !important;
  height: 12px;
  color: white;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

p.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 0px;
  text-align:center;
  color: gray;
  font-size: 9px;
  height: 16px;
  padding: 0px;
  margin: 0px;
}

span.emoji {
  font-size: 48px;
  line-height: 48px;
  vertical-align: middle;
  color: #ffffffff;
}

span.text {
  font-size: 14px;
  /* vertical-align: middle; */
  color: black !important;
  border-radius: 4px;
  max-width: 70% !important;
  background-color: #E1F5FE80;
  display: inline-block;
  white-space: pre-wrap;
}

span.text-r {
  font-size: 14px;
  /* vertical-align: middle; */
  color: black !important;
  border-radius: 4px;
  max-width: 70% !important;
  background-color: #FFCCBC40;
  display: inline-block;
  white-space: pre-wrap;
}

.scroller {
  height: 100%;
}

.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.v-sheet.box {
  overflow-x: hidden;
  /* border-bottom: 1px solid gray !important; */
  /* border-left: 0.1px solid gray; */
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

</style>
